/**
* @file 营销管理-优惠券管理
* */
<template>
  <div id="coupon">


    <custom-table ref="customTable" :customOptions="customOptions" :columns="columns" :showOrganization="true">
      <template slot="search-top-left">
        <div class="condition">
          <el-select v-if="mixinUserInfo.organizationType === 1" v-model="customOptions.params.organizationId"
            placeholder="请选择机构名称" @change="sortFn" filterable clearable>
            <el-option v-for="val in organizations" :key="val.id" :value="val.id" :label="val.name">
            </el-option>
          </el-select>
          <span style="line-height: 28px; margin-right: 0">状态：</span>
          <el-radio-group v-model="customOptions.params.status" @change="sortFn">
            <el-radio-button label="">全部</el-radio-button>
            <el-radio-button :label="item.value" v-for="item in $const.COUPONSTATUS" :key="item.value">{{ item.label }}
            </el-radio-button>
          </el-radio-group>
        </div>
      </template>
      <template slot="search-top-right">
        <el-button type="primary" @click="$router.push('/couponForm')">添加优惠券</el-button>
      </template>
      <template slot="table-operation">
        <el-table-column label="操作" fixed="right" width="100">
          <div slot-scope="{ row }" class="custom-action">
            <el-button type="text" v-if="row.isActiveFailure !== 1" @click="setClick(row)">补充</el-button>
            <el-button style="color: #f00;" type="text" v-if="row.status === 1" @click="statusFn(row)">失效</el-button>
            <el-button style="color: #f00;" type="text" v-if="row.status === 2" @click="removeClick(row)">删除</el-button>
            <!-- <el-tooltip content="补充数量" placement="top" v-if="row.isActiveFailure !== 1">
              <i class="iconfont icon-jia" @click="setClick(row)"></i>
            </el-tooltip>
            <el-tooltip content="失效" placement="top" v-if="row.status === 1">
              <i class="iconfont icon-shixiao" @click="statusFn(row)"></i>
            </el-tooltip>
            <el-tooltip content="删除" placement="top" v-if="row.status === 2">
              <i class="iconfont icon-delete" @click="removeClick(row)"></i>
            </el-tooltip> -->
          </div>
        </el-table-column>
      </template>
      <template slot-scope="{ item, row }">
        <template v-if="item.prop === 'created'">{{
          row.created | filterTime
        }}</template>
        <template v-else-if="item.prop === 'type'">{{
          row[item.prop] | filterConst("COUPONTYPE")
        }}</template>
        <template v-else-if="item.prop === 'obtainMethod'">{{ row[item.prop] | filterConst("COUPONOBTAINMETHOD") }}
        </template>
        <template v-else-if="item.prop === 'status'">
          <el-tag size="small" :type="row[item.prop] | filterConst('COUPONSTATUS', 'type')">{{ row[item.prop] |
            filterConst("COUPONSTATUS") }}</el-tag>
        </template>
        <template v-else-if="item.prop === 'limitFee'">
          <div>订单金额 ≥ {{ row.limitFee }}元</div>
          <div v-if="row.limitAgeMin && row.limitAgeMax">乘车人年龄≥{{row.limitAgeMin}}周岁，≤{{row.limitAgeMax}}周岁</div>

        </template>
        <template v-else-if="item.prop === 'validityType'">
          <span v-if="row[item.prop] === 1">领券{{ row.naturalDay }}天后失效</span>
          <span v-else-if="row[item.prop] === 2">{{ row.expirationDay | filterTime }}失效</span>
          <span v-else>-</span>
        </template>
        <template v-else-if="item.prop === 'issuedNum'">
          {{ row.remainingNum }} / {{ row.issuedNum }}
        </template>
        <template v-else-if="item.prop === 'useLineType'">
          <span v-if="row.useLineType == 2" style="color: #0066ff; cursor: pointer" @click.stop="lineListView(row)">
            查看
          </span>
          <span v-else>全部</span>
        </template>
        <template v-else>{{ row[item.prop] ? row[item.prop] : "-" }}</template>
      </template>
    </custom-table>

    <!--设置轮播速度弹框-->
    <el-dialog title="补充数量" :visible.sync="visible" width="400px" :close-on-click-modal="false">
      <el-form label-position="left" :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="数量" prop="supplementNum">
          <el-input v-model="form.supplementNum" maxlength="8" placeholder="请输入要补充的数量">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">关 闭</el-button>
        <el-button type="primary" @click="postBannerTime" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>


    <el-dialog title="适用线路" :visible.sync="viewVisible" @close="viewData = []" width="45%" append-to-body>
      <p style="color: #999; margin-bottom: 10px">
        说明：被删除的线路，在本列表也会自动移除
      </p>
      <el-table :data="viewData" :max-height="577" style="width: 100%" border>
        <el-table-column label="出发地">
          <template slot-scope="scope">
            <p>{{ scope.row.startStationName }}</p>
            <p style="color: #999">{{ scope.row.startProvincialCity }}</p>
          </template>
        </el-table-column>
        <el-table-column label="目的地">
          <template slot-scope="scope">
            <p>{{ scope.row.endStationName }}</p>
            <p style="color: #999">{{ scope.row.endProvincialCity }}</p>
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "carousel",
  data() {
    return {
      // 配置项
      customOptions: {
        // 请求的列表url
        url: "/api/v1/manage/coupon",
        params: {
          status: "",
          page: 1, // 页数
          size: 20, // 每页条数
        },
      },
      // 表头
      columns: [
        { prop: "name", label: "优惠券名称" },
        { prop: "explanation", label: "优惠券说明" },
        { prop: "type", label: "类型" },
        { prop: "status", label: "状态",minWidth:80 },
        { prop: "validityType", label: "有效期",minWidth:110  },
        { prop: "issuedNum", label: "数量(剩余/总量)" },
        { prop: "obtainMethod", label: "获取方式",minWidth: 120 },
        { prop: "limitFee", label: "使用条件",minWidth: 160 },
        { prop: "useLineType", label: "适用线路" },
        { prop: "created", label: "创建时间" },
      ],
      // 设置轮播速度的弹框
      visible: false,
      // 设置轮播速度对象
      form: {},
      loading: false,
      // 校验规则
      rules: {
        supplementNum: [
          { required: true, message: "请输入数量" },
          { pattern: /^[1-9]\d*?$/, message: "请输入正确的数字" },
        ],
      },
      viewTitle: "",
      viewVisible: false,
      viewData: [],
    };
  },
  created() {
    this.mixinOrganizations();
  },
  methods: {
    async lineListView(row) {
      let formIURL = "/api/v1/manage/coupon/line/" + row.id;
      let data = await this.$axios.get(formIURL);
      if (data && data.code === 1) {
        this.viewData = data.data || [];
      }
      this.viewVisible = true;
    },
    /**
     * 状态改变
     */
    sortFn() {
      this.customOptions.params.page = 1;
      this.$refs.customTable.listFn();
    },
    statusFn(row) {
      this.$confirm(
        "置为失效后，该券将无法被领取，确定这样做吗？",
        "提示"
      ).then(async () => {
        let url = "/api/v1/manage/coupon";
        let params = {
          id: row.id,
          status: 2,
        };
        let data = await this.$axios.put(url, params);
        if (data && data.code === 1) {
          this.$message.success("操作成功");
          this.$refs.customTable.listFn();
        }
      });
    },
    /**
     * 设置轮播速度
     */
    setClick(row) {
      // 类型为截至日过期失效则不能添加，数量为0失效可以添加
      if (
        row.status === 2 &&
        row.validityType === 2 &&
        row.expirationDay * 1000 < Date.now()
      ) {
        this.$message.warning("该优惠卷已过期，无法补充数量");
        return;
      }
      this.form = {
        id: row.id,
      };
      if (this.$refs.form) {
        this.$refs.form.resetFields();
      }
      this.visible = true;
    },
    /**
     * 轮播速度保存
     */
    postBannerTime() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.loading = true;
          let url = "/api/v1/manage/coupon";
          let data = await this.$axios.put(url, this.form);
          this.loading = false;
          if (data && data.code === 1) {
            this.visible = false;
            this.$message.success("设置成功！");
            this.$refs.customTable.listFn();
          }
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    },
    /**
     * 列表-删除
     */
    async removeClick(row) {
      let url = "/api/v1/manage/coupon";
      let params = {
        id: row.id,
      };
      let data = await this.$axios.delete(url, params);
      if (data && data.code === 1) {
        this.$message.success("删除成功");
        this.$refs.customTable.listFn();
      }
    },
  },
};
</script>

<style lang="less">
#coupon {
  .condition {
    &>* {
      vertical-align: top;
      margin-right: 30px;
    }
  }
}
</style>
